import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { data, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { fetchContent } from "../../redux/slices/contentSlice";
import { fetchMenuGroup } from "../../redux/slices/menuGroupSlice";
import API from "../../api";

const Footer = () => {
  const dispatch = useDispatch();
  const { dataContent } = useSelector((state) => state.content);
  const { dataMenuGroup } = useSelector((state) => state.menuGroup);
  const { dataSettings } = useSelector((state) => state.settings);
  const { t } = useTranslation();
  const lang = useSelector((state) => state.lang.lang);

  const [footerImg, setFooterImg] = useState("");
  const [footerText, setFooterText] = useState("");
  const [copyright, setCopyright] = useState("");
  const [footerMenus, setFooterMenus] = useState([]);

  useEffect(() => {
    dispatch(fetchContent());
    dispatch(fetchMenuGroup());
  }, [dispatch]);

  useEffect(() => {
    if (dataSettings && dataSettings.banner) {
      setFooterImg(`${API.BASE}${dataSettings.banner}`);
    }
  }, [dataSettings]);

  useEffect(() => {
    if (dataContent) {
      setFooterText(dataContent.footerText?.[lang] || "");
      setCopyright(dataContent.footerText2?.[lang] || "");
    }
  }, [dataContent, lang]);

  useEffect(() => {
    if (Array.isArray(dataMenuGroup)) {
      const footerMenuGroup = dataMenuGroup.find(
        (group) => group?.title?.[lang] === "Footer Menu"
      );
      if (footerMenuGroup && Array.isArray(footerMenuGroup.menus)) {
        setFooterMenus(
          [...footerMenuGroup.menus].sort(
            (a, b) => (a.sort ?? 0) - (b.sort ?? 0)
          )
        );
      }
    }
  }, [dataMenuGroup, lang]);

  return (
    <div className="footer">
      <div className="up">
        {footerImg && <img src={footerImg} alt="Footer Logo" />}
        <div className="w-100 text-center">
          <span className="f40 fw500 color3">{footerText}</span>
        </div>
      </div>
      <div className="down">
        <ul>
          {footerMenus.map((menu) => (
            <li key={menu.id}>
              <Link to={`/${menu.slug?.[lang] || ""}`}>
                {menu.title?.[lang] || ""}
              </Link>
            </li>
          ))}
        </ul>
        <div className="copyright">
          <span>{copyright}</span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
